function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

class ProductTemplate extends HTMLElement {
    constructor() {
        super();
        this.firsLoad = true;
        this.init();

    }

    init() {
        this.initSlider();


        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.querySelector('.product-form__buttons [name="add"]').addEventListener('click', () => {
            this.submitForm();
        });


        if (this.querySelector('[data-nb-gelules]')) {
            this.querySelector('[data-nb-gelules]').textContent = this.querySelector('[data-current-nb-gelule]').getAttribute('data-current-nb-gelule')
            this.querySelector('[data-nb-month]').textContent = this.querySelector('[data-current-month]').getAttribute('data-current-month')
        }

        window.addEventListener('load', () => {
           this.querySelector('.to_clicked').click();
           this.querySelector('.to_clicked_sub').click();
        });
    }

    submitForm() {
        const productItems = document.querySelectorAll('.product-list__item');

        let json = { items: [] };
        let totalQuantity = 1;
        let url = '';
        let id = Number(this.querySelector('[data-product-add]').dataset.productAdd);
        let quantity = Number(document.querySelector('.product-form__input input:checked').dataset.quantity);
        if (document.querySelector('[data-subscribe="true"].actif')) {
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(function (response) {

                    if (response.ok) {
                        url += `cart/add?items[][id]=${id}&items[][quantity]=${quantity}&items[][selling_plan]=${Number(document.querySelector('.product-pack__recurring-current-value[data-selling-plan-id]').getAttribute('data-selling-plan-id'))}&return_to=/checkout`;
                        window.location.href = url;
                    } else {
                        console.error('Erreur lors de la tentative de vider le panier:', response.status);
                    }
                })
                .catch(function (error) {
                    console.error('Erreur réseau:', error);
                });
        } else {
            url = '/cart/';
            id = this.querySelector('[data-product-add]').dataset.productAdd;
            quantity = document.querySelector('.product-form__input input:checked').dataset.quantity;
            url += `${id}:${quantity},`;
            if (totalQuantity != 0) {
                window.location.href = url;
            }
        }

        console.log(url);


        console.log(json);


    }

    initSlider() {
        this.swiperThumb = new Swiper(this.querySelector('.swiper-thumb-media'), {
            slidesPerView: 'auto',
            direction: 'horizontal',
            centeredSlides: false,
            loopedSlides: this.querySelector('[data-media-size]').dataset.mediaSize,
            loop: false,
            slideToClickedSlide: true,
            autoScrollOffset: 1,
            cssMode: true,
        });

        this.swiper = new Swiper(this.querySelector('.swiper-media'), {
            direction: 'horizontal',
            slidesPerView: 1,
            loopedSlides: this.querySelector('[data-media-size]').dataset.mediaSize,
            thumbs: {
                swiper: this.swiperThumb,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        });
        this.firsLoad = false;
    }

    toggleFaqItem(e) {

        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', ProductTemplate);




if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cartNotification = document.querySelector('cart-notification');
            this.submitButton = this.querySelector('[type="submit"]');
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();
            this.cartNotification.setActiveElement(document.activeElement);

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    }

                    this.error = false;
                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                        document.body.addEventListener('modalClosed', () => {
                            setTimeout(() => { this.cartNotification.renderContents(response) });
                        }, { once: true });
                        quickAddModal.hide(true);
                    } else {
                        this.cartNotification.renderContents(response);
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}


class ReccuringOption extends HTMLElement {
    constructor() {
        super();



        this.addEventListener("click", this.selectOption.bind(this));

        if (this.dataset.subscribe === "true") {
            this.initEventSelectReccuring();
        } else {

        }

        if (document.querySelector('.product-composer')) {
            window.addEventListener('load', () => {
                document.querySelector('product-item').uptadePrice();
            });
        }

        // check if click outside .product-pack__recurring-select-values and close it
        document.addEventListener("click", (event) => {
            if (event.target.closest(".product-pack__recurring-select") === null) {
                this.querySelector(".product-pack__recurring-select-values")
                    ? this.querySelector(
                        ".product-pack__recurring-select-values"
                    ).classList.add("hidden")
                    : null;
                this.querySelector(".product-pack__recurring-select")
                    ? this.querySelector(
                        ".product-pack__recurring-select"
                    ).classList.remove("actif")
                    : null;
            }
        });
    }

    initEventSelectReccuring() {
        this.querySelectorAll(
            ".product-pack__recurring-current, .product-pack__recurring-select svg"
        ).forEach((select) => {
            select.addEventListener("click", (event) => {
                event.preventDefault();
                this.querySelector(
                    ".product-pack__recurring-select-values"
                ).classList.toggle("hidden");
                this.querySelector(".product-pack__recurring-select").classList.toggle(
                    "actif"
                );
            });
        });

        this.querySelectorAll(
            ".product-pack__recurring-select-values label"
        ).forEach((select) => {
            select.addEventListener("click", (event) => {
                event.preventDefault();
                this.querySelector(
                    ".product-pack__recurring-current"
                ).innerHTML = `<span class="product-pack__recurring-current-value" data-selling-plan-id="${event.currentTarget
                    .getAttribute("for")
                    .replace("selling_plan_", "")}">${event.target.innerHTML}</span>`;
                this.querySelector(
                    ".product-pack__recurring-select-values"
                ).classList.toggle("hidden");
                this.querySelector(".product-pack__recurring-select").classList.remove(
                    "actif"
                );

                document
                    .querySelectorAll(".product-pack__recurring-select-values label")
                    .forEach((label) => {
                        label.classList.remove("actif");
                        if (
                            label.getAttribute("for") ===
                            event.currentTarget.getAttribute("for")
                        ) {
                            console.log(document.querySelector(`.selling__inputs #${label.getAttribute("for")}`));

                            label.classList.add("actif");
                            document.querySelector(`.selling__inputs #${label.getAttribute("for")}`).setAttribute('checked', 'checked');
                        }
                    });
                document.querySelector('[data-sub-month]').textContent = document.querySelector('.product-pack__recurring-select-values label.actif').getAttribute('data-index-current');
            });
        });

    }

    updatePriceCta() {
        const is_subscription = document.querySelector(
            '[data-subscribe="true"].actif'
        )
            ? true
            : false;

    }

    selectOption(event) {

        document.querySelectorAll("recurring-option").forEach((option) => {
            option.classList.remove("actif");
        });

        this.classList.add("actif");

        if (document.querySelector('[data-subscribe="true"].actif')) {
            document.querySelector('.product-form__buttons [data-current-price]').textContent = this.querySelector('[data-sub-price]').textContent ? this.querySelector('[data-sub-price]').textContent : this.querySelector('[data-sub-price] span').textContent
        } else {
            document.querySelector('.product-form__buttons [data-current-price]').textContent = this.querySelector('[data-current-price]').textContent ? this.querySelector('[data-current-price]').textContent : this.querySelector('[data-current-price] span').textContent

        }

        if (document.querySelector('.product-composer')) {
            document.querySelector('product-item').uptadePrice();
        }


        if (this.dataset.subscribe === "true") {
            document.querySelector('.selling__inputs .first').setAttribute('checked', 'checked');
            document.querySelectorAll('.selling__inputs input').forEach((input) => {
                input.removeAttribute('checked');
            });
            document.querySelector(`.selling__inputs #${document.querySelector('.product-pack__recurring-select-values .actif').getAttribute("for")}`).setAttribute('checked', 'checked')
            document.querySelector('.sub-content').classList.add('active');
        } else {

            document.querySelector('.sub-content').classList.remove('active');
            document.querySelectorAll('.selling__inputs input').forEach((input) => {
                input.removeAttribute('checked');
            });

        }

        this.updatePriceCta();
    }
}

if (customElements.get("recurring-option") === undefined) {
    customElements.define("recurring-option", ReccuringOption);
}
